<template>

  <div class="container-fluid" style="">
    <!--<div class="row" style="padding-top: 1em">-->
    <h1 v-if="!podgrupa"> {{$t('pages.adminpanel.subgroup.editSubgroup')}} </h1>
    <br v-else-if="!podgrupa">
    <div v-else-if="stopUpdate || Upodgrupa()"></div>
    <select v-if="!podgrupa" v-model="groupEdit">
      <option v-for="group in groupList">{{ group.name }}</option>
      <!-- translate -->
    </select>
    <hr>
    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-2" for="name">{{$t('pages.adminpanel.subgroup.editName')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="save" type="text" id='name' class="form-control" v-model="subgroupName" v-bind:readonly="isReadOnly">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="description">{{$t('pages.adminpanel.subgroup.editDescription')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="save" type="text" id='description' class="form-control" v-model="subgroupDescription" v-bind:readonly="isReadOnly">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="video_link">{{$t('pages.adminpanel.subgroup.editVideoLink')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="save" type="text" id='video_link' class="form-control" v-model="subgroupVideoLink" v-bind:readonly="isReadOnly">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="video_time">{{$t('pages.adminpanel.subgroup.editVideoTime')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="save" type="text" id='video_time' class="form-control" v-model="subgroupVideoTime" v-bind:readonly="isReadOnly">
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <div class="checkbox">
            <label>
              <input v-model="podgrupa.visible" type="checkbox"> {{$t('pages.adminpanel.subgroup.visibility')}}
            </label>
          </div>
          <!-- <div class="checkbox text-center">
            <label>
              <input v-model="public_a" type="checkbox"> {{$t('pages.createGroup.public')}}
            </label>
          </div> -->
          <button v-if="!isReadOnly" @click.prevent.stop="save" class="btn btn-app pull-right">
            <i class="fa fa-save"></i>{{Save}}
          </button>
          <a v-if="subgroupName != ''" class="btn btn-danger pull-left margin" @click.prevent.stop="deleteGroup()">
            <i class="fa fa-trash"></i>
          </a>
        </div>
        <div class="col-sm-offset-2 col-sm-10">
          <div class="pull-right">
            <a class="btn btn-box-tool" @click.prevent.stop="closeDropdown()">
              <i class="fa fa-caret-up"></i>
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
import Rest from './../../../services/rest'
// import router from './../../router/router'
export default {
  data () {
    return {
      groupId: '',
      groupName: '',
      groupDesc: '',
      coverURL: '',
      isReadOnly: true,
      glyphSectionClosed: 'glyphicon glyphicon-triangle-right',
      glyphSectionOpen: 'glyphicon glyphicon-triangle-down',
      groupList: '',
      groupEdit: '',
      groupPublic: false,
      stopUpdate: false,
      Edit: this.$t('pages.buttons.edit'),
      Save: this.$t('pages.buttons.save'),
      subgroupName: this.$options.filters.pickTranslation(this.podgrupa.name),
      subgroupDescription: this.$options.filters.pickTranslation(this.podgrupa.description),
      public_a: this.podgrupa && this.podgrupa.public,
      subgroupVideoLink: this.podgrupa.youtube_link,
      subgroupVideoTime: this.podgrupa.youtube_time
    }
  },
  props: {
    podgrupa: Object
  },
  methods: {
    edit: function () {
      this.isReadOnly = false
    },
    save: function () {
      this.isReadOnly = true
      var tren = this
      var postdata = {
        subgroupId: this.podgrupa.id,
        name: this.subgroupName,
        description: this.subgroupDescription,
        visible: this.podgrupa.visible,
        public: this.public_a,
        youtubeLink: this.subgroupVideoLink,
        youtubeTime: this.subgroupVideoTime
      }
      let translLanguage
      for (let key in tren.podgrupa.name) {
        if (tren.podgrupa.name[key] === this.$options.filters.pickTranslation(this.podgrupa.name)) {
          translLanguage = key
        }
      }
      tren.Save = tren.$t('pages.buttons.success')
      return Rest.request('PUT', '/subgroups/' + tren.podgrupa.id, postdata).then((data) => {
        tren.$set(tren.podgrupa, 'showEdit', false)
        // this.$options.filters.pickTranslation()
        tren.podgrupa.name[translLanguage] = this.subgroupName
        tren.podgrupa.description = this.subgroupDescription
        tren.podgrupa.public = tren.public_a
        tren.podgrupa.youtube_link = this.subgroupVideoLink
        tren.podgrupa.youtube_time = this.subgroupVideoTime
        // tren.podgrupa.showEdit2 = !tren.podgrupa.showEdit2
        // EventBus.$emit('updateDOM', 'true')
        // tren.$store.state.adminpanel.colapseEdit = !tren.$store.state.adminpanel.colapseEdit // if success colapse
      }).catch(function (err) {
        console.log(err)
        tren.Save = err.statusText
      })
    },
    getGroup (name) {
      for (let i = 0; i < this.groupList.length; i++) {
        if (this.groupList[i].name === name) return this.groupList[i]
      }
    },
    getGroups: function () {
      var tren = this
      return Rest.request('GET', '/groups').then(function (data) {
        tren.groupList = data
      }).catch(function (err) {
        console.log(err)
      })
    },
    deleteGroup (force) {
      var answer = confirm(force ? force.message : this.$t('pages.buttons.deleteP'))
      if (answer) {
        var deletedata = {
          force: 'true'
        }
        var tren = this
        tren.Save = tren.$t('pages.buttons.success')
        return Rest.request('DELETE', '/subgroups/' + tren.podgrupa.id, deletedata).then((data) => {
          tren.groupName = ''
          this.$store.commit('deleteSubgroup', tren.podgrupa)
        }).catch((err) => {
          tren.Save = err.statusText
          console.log(err)
        })
      }
    },
    updateEdit (group) {
      if (group) {
        this.groupName = group.name
        this.groupDesc = group.description
        this.coverURL = group.coverUrl
        this.groupId = group.id
        this.groupPublic = group.public
        this.stopUpdate = true
      }
    },
    groupEdit (val) {
      this.updateEdit(this.getGroup(val))
    },
    Upodgrupa () {
      if (this.podgrupa === '') return false
      this.updateEdit(this.getGroup(this.podgrupa))
      this.edit()
      return true
    },
    closeDropdown () {
      this.$set(this.podgrupa, 'showEdit', !this.podgrupa.showEdit)
    }
  },
  created () {
    if (!this.podgrupa) this.getGroups()
  },
  watch: {
    groupEdit (val) {
      this.updateEdit(this.getGroup(val))
    }
  },
  computed: {
    showEdit2: {
      get: function () {
        return this.showEdit
      },
      set (newValue) {
        this.showEdit = newValue
      }
    }
  }
}
</script>

<style>

/*<!-- SASS styling -->*/
/*<style lang="scss">*/
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: #f1eff7; /* ali lightcyan*/
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  .fa-caret-up {
    color: white
  }
</style>



// WEBPACK FOOTER //
// EditSubgroup.vue?a53f10c8